import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";

export const OurBestCars = () => {
  return (
    <Container fluid>
      <Container className="py-4">
        <Row className="py-4 align-items-center">
          <Col lg="6">
            <div className="p-2">
              <h2 className="text-4xl colorGreen font-bold">Our Best Cars</h2>
            </div>
          </Col>
          <Col lg="6">
            <div className="p-2">
              <div className="d-flex gap-6 float-right">
                {/* <div>
            <h2 className="text-lg" style={{ color: "#C7C7C7" }}>
              View as
            </h2>
          </div> */}
                <div className="d-flex gap-3 align-items-center">
                  <h2 className="text-xl text-black font-semibold">
                    Car Type:
                  </h2>
                  <select name="size" id="size" className="p-2">
                    <option value="0" selected="">
                      4 Seater
                    </option>
                    <option value="9">6 Seater</option>
                    <option value="8">2 Seater</option>
                    <option value="7">10 Seater</option>
                  </select>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4">
            <div className="text-center bg-black border-black rounded-md mt-2">
              <div className="rounded-md">
                <Image src={require("../../assets/SliderAqua.png")} />
              </div>
              <div className="p-2 webkit justify-center">
                <h2 className="font-semibold text-xl text-white">
                  Small 5dr Hatchback
                </h2>
                <Row className="justify-center rrr py-2">
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        PKR{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          5000
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        GBP{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          20.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        USD{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          25.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                </Row>
              </div>
              <hr className="hr" />
              <Row className="p-2 justify-center align-items-center">
                <Col className="text-left">
                  <p className="text-white font-medium">
                    Approximately per day price
                  </p>
                </Col>
                <Col className="text-right">
                  <button className="bg-slate-200 btn text-black font-semibold">
                    Book Now
                  </button>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg="4">
            <div className="text-center bg-black border-black rounded-md mt-2">
              <div className="rounded-md">
                <Image src={require("../../assets/SliderAqua.png")} />
              </div>
              <div className="p-2 webkit justify-center">
                <h2 className="font-semibold text-xl text-white">
                  Small 5dr Hatchback
                </h2>
                <Row className="justify-center rrr py-2">
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        PKR{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          5000
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        GBP{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          20.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        USD{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          25.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                </Row>
              </div>
              <hr className="hr" />
              <Row className="p-2 justify-center align-items-center">
                <Col className="text-left">
                  <p className="text-white font-medium">
                    Approximately per day price
                  </p>
                </Col>
                <Col className="text-right">
                  <button className="bg-slate-200 btn text-black font-semibold">
                    Book Now
                  </button>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg="4">
            <div className="text-center bg-black border-black rounded-md mt-2">
              <div className="rounded-md">
                <Image src={require("../../assets/SliderAqua.png")} />
              </div>
              <div className="p-2 webkit justify-center">
                <h2 className="font-semibold text-xl text-white">
                  Small 5dr Hatchback
                </h2>
                <Row className="justify-center rrr py-2">
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        PKR{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          5000
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        GBP{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          20.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div>
                      <h2 className="text-lg text-white">
                        USD{" "}
                        <span className="colorGreen font-extrabold text-2xl">
                          25.00
                        </span>
                      </h2>
                    </div>
                  </Col>
                </Row>
              </div>
              <hr className="hr" />
              <Row className="p-2 justify-center align-items-center">
                <Col className="text-left">
                  <p className="text-white font-medium">
                    Approximately per day price
                  </p>
                </Col>
                <Col className="text-right">
                  <button className="bg-slate-200 btn text-black font-semibold">
                    Book Now
                  </button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
